import { render } from "./Message.vue?vue&type=template&id=a4349c02&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=a4349c02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4349c02"

export default script